import React from 'react'
import { connect } from 'react-redux'
import { compose, branch, renderNothing, renderComponent } from 'recompose'
import _map from 'lodash/map'
import Icon from 'svg-inline-react'
import { Button, Select, Input } from '@driftt/tide-core-legacy'

import {
  salesforceLeadSettings,
  salesforceContactSettings,
  salesforceEventSettings,
  salesforceTaskSettings,
} from 'app/modules/assistantSettings/selectors'

const closeSRC = require('!svg-inline?removeTags=true!images/svg/close-icon-circle.svg')

const DefaultDisabledState = () => {
  return (
    <div className="assistant-settings-column">
      <div className="SFDC-value-row">
        <Input placeholder="SFDC value..." disabled="true" />
      </div>
    </div>
  )
}

class SFDCValues extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      canAddEmptyValue: props.filteredSelections.size === props.sfValueSelections.size,
    }
  }

  componentDidMount() {
    if (this.props.sfValueSelections.size === 0) {
      this.addEmptyValue()
    }
  }

  addEmptyValue = () => {
    this.setState({ canAddEmptyValue: false })
    this.props.inputHandler('', this.props.sfValueSelections.size, this.props.sfField)
  }

  inputHandlerWrapper = (value, index, sfField) => {
    this.setState({ canAddEmptyValue: true })
    this.props.inputHandler(value, index, sfField)
  }

  removeHandlerWrapper = (index, sfField) => {
    if (this.props.filteredSelections.size !== this.props.sfValueSelections.size) {
      this.setState({ canAddEmptyValue: false })
    }
    this.props.removeHandler(index, sfField)
    if (this.props.filteredSelections.size === 1) {
      this.props.removeFieldHandler()
    }
  }

  salesforceFieldValueOptionsHelper = (sfFieldValue, isPicklist, index) => {
    const { sfField, sfFieldValuesKey, salesforceSettings } = this.props
    const salesforceFieldValueOptions = {
      autoFocus: sfFieldValue === '',
      placeholder: 'SFDC value...',
      disabled: !sfField,
      value: sfFieldValue,
      onChange: event => this.inputHandlerWrapper(event.target.value, index, sfField),
    }
    const salesforceFieldPicklistValueOptions = {
      autoFocus: sfFieldValue === '',
      multi: false,
      clearable: false,
      placeholder: 'SFDC value...',
      disabled: !sfField,
      value: sfFieldValue,
      onChange: ({ value }) => this.inputHandlerWrapper(value, index, sfField),
    }

    if (sfField && isPicklist) {
      salesforceFieldPicklistValueOptions['options'] = salesforceSettings.get(sfFieldValuesKey)[sfField][
        'picklistValues'
      ]
    }

    return { salesforceFieldValueOptions, salesforceFieldPicklistValueOptions }
  }

  renderSFDCValue(sfField, sfFieldValue, index, salesforceSettings, sfFieldValuesKey, isPicklist) {
    const {
      salesforceFieldValueOptions,
      salesforceFieldPicklistValueOptions,
    } = this.salesforceFieldValueOptionsHelper(sfFieldValue, isPicklist, index)

    return (
      <div className="SFDC-value-row" key={`SFDC-value-${index}`}>
        {isPicklist ? (
          <Select {...salesforceFieldPicklistValueOptions} />
        ) : (
          <Input {...salesforceFieldValueOptions} />
        )}
        {sfFieldValue && (
          <div className="remove-value-button">
            <Icon src={closeSRC} onClick={() => this.removeHandlerWrapper(index, sfField)} />
          </div>
        )}
      </div>
    )
  }

  render() {
    const {
      sfField,
      sfValueSelections,
      filteredSelections,
      salesforceSettings,
      sfFieldValuesKey,
    } = this.props
    const { canAddEmptyValue } = this.state
    const isPicklist = sfField
      ? salesforceSettings.get(sfFieldValuesKey)[sfField]['valueType'] === 'picklist'
      : false

    return (
      <div className="assistant-settings-column">
        {_map(sfValueSelections.toJS(), (sfFieldValue, index) =>
          this.renderSFDCValue(sfField, sfFieldValue, index, salesforceSettings, sfFieldValuesKey, isPicklist)
        )}
        <div className="input-container">
          <div className="SFDC-add-value-row">
            {filteredSelections.size > 0 && (
              <Button
                type="subtle"
                className="SFDC-add-value-button"
                disabled={!canAddEmptyValue}
                onClick={this.addEmptyValue}
              >
                + Add Value
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  return (state, props) => {
    const { sfObjectType } = props

    let salesforceSettings = salesforceLeadSettings(state)
    let sfFieldValuesKey = 'leadFieldValues'
    switch (sfObjectType) {
      case 'CONTACT':
        salesforceSettings = salesforceContactSettings(state)
        sfFieldValuesKey = 'contactFieldValues'
        break
      case 'EVENT':
        salesforceSettings = salesforceEventSettings(state)
        sfFieldValuesKey = 'eventFieldValues'
        break
      case 'TASK':
        salesforceSettings = salesforceTaskSettings(state)
        sfFieldValuesKey = 'taskFieldValues'
        break
    }

    return {
      salesforceSettings,
      sfFieldValuesKey,
    }
  }
}

export default compose(
  connect(makeMapStateToProps),
  branch(props => !props.sfField, renderComponent(DefaultDisabledState)),
  branch(props => !props.orgSettings, renderNothing)
)(SFDCValues)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/AssistantConfigOrg/SFDCValues/index.js